import { useQuery } from '@apollo/client';
import { useState, useEffect } from 'react';
import { Paper } from '@material-ui/core';
import { TabGroup } from './TabGroup';
import { useIsFeatureFlagEnabled } from '../contexts/feature-flag-context';
import { Priorities } from './Priorities';
import { MyBoards } from './MyBoards';

import red from '@material-ui/core/colors/red';
import orange from '@material-ui/core/colors/orange';
import yellow from '@material-ui/core/colors/yellow';
import green from '@material-ui/core/colors/green';
import Loader from './Loader';
import { MyBoardsHome } from '../queries/myBoards';

import { useStyles } from '../theme';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2)
  },
  red: {
    color: red[500]
  },
  orange: {
    color: orange[800]
  },
  yellow: {
    color: yellow[600]
  },
  green: {
    color: green[900]
  },
  critical: {
    backgroundColor: red[100]
  },
  high: {
    backgroundColor: orange[100]
  },
  medium: {
    backgroundColor: yellow[100]
  },
  low: {
    backgroundColor: green[100]
  },
  statsGrid: {
    textAlign: 'center'
  },
  filterButton: {
    textTransform: 'none'
  }
});

const allLabel = (count = 0) => {
  return { id: 'all', name: 'all', displayName: 'All', boardCount: count };
};

export const Home = () => {
  const classes = useStyles(styles);
  const tabGroupFlag = useIsFeatureFlagEnabled('vip-fe-add-tab-groups');
  const [labels, setLabels] = useState([]);
  const [appliedLabel, setAppliedLabel] = useState('all');
  const [currentBoards, setCurrentBoards] = useState([]);

  const { loading, error, data } = useQuery(MyBoardsHome, {
    variables: {
      withLabels: tabGroupFlag
    },
    fetchPolicy: 'network-only',
    pollInterval: 30000
  });

  const findBoardsByLabel = (labelId) => {
    return labelId === 'all'
      ? data.myBoards
      : data.myBoards.filter((board) =>
          board.labels?.some((l) => l.id === labelId)
        );
  };

  useEffect(() => {
    if (data) {
      const totalBoardsCount = data?.myBoards?.length;
      setLabels([allLabel(totalBoardsCount), ...data?.labels?.toSorted((label1, label2) => label1.id - label2.id) || []]);
      setCurrentBoards(findBoardsByLabel(appliedLabel));
    }
    // intentional to only run when data changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleAppliedLabelChange = (labelId) => {
    setAppliedLabel(labelId);
    setCurrentBoards(findBoardsByLabel(labelId));
  };

  return (
    <Paper square className={classes.root}>
      {loading && <Loader />}
      {error && <div>Error</div>}
      {!loading && !error && data.allBucketCounts && data.gigCountsByRule && (
        <Priorities
          allBucketCounts={data.allBucketCounts}
          gigCountsByRule={data.gigCountsByRule}
        />
      )}
      {tabGroupFlag && labels.length > 0 && (
        <TabGroup tabs={labels} setAppliedTab={handleAppliedLabelChange} />
      )}
      {loading && <Loader />}
      {error && <div>Error</div>}
      {data && <MyBoards myBoards={currentBoards} />}
    </Paper>
  );
};
